import { render, staticRenderFns } from "./AbschnittMethode.vue?vue&type=template&id=5d12fc36&"
import script from "./AbschnittMethode.vue?vue&type=script&lang=js&"
export * from "./AbschnittMethode.vue?vue&type=script&lang=js&"
import style0 from "./AbschnittMethode.vue?vue&type=style&index=0&id=5d12fc36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports